import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.BUSINESS };
const path = "business/business-profile";
const publicPath = "business/auth";

export const ChangePassword = async (values) => {
  return await axiosInstance(options).post(`${path}/change-password`, values);
};

// Below API's are being used in the Edit Business Info
export const categoriesList = async (values) => {
  return await axiosInstance(options).get(`${publicPath}/categories-list`, values);
};

export const subcategoriesList = async (values) => {
  return await axiosInstance().post(`${publicPath}/subcategories-list`, values);
};

export const editBusinessInfo = async (values) => {
  return await axiosInstance(options).post(`${path}/edit`, values);
};

export const getUserInfo = async (values) => {
  return await axiosInstance(options).get(`${path}/details`, values);
};

export const updateDescription = async (values) => {
  return await axiosInstance(options).post(`${path}/update-description`, values);
};

export const updateOpeningHours = async (values) => {
  return await axiosInstance(options).post(`${path}/update-opening-hours`, values);
};

export const updateNotification = async (values) => {
  return await axiosInstance(options).post(`${path}/update-notification`, values);
};

export const getLocationDetails = async (values) => {
  return await axiosInstance(options).get(`${path}/get-location-details`, values);
};

export const updateLocationDetails = async (values) => {
  return await axiosInstance(options).post(`${path}/update-location-details`, values);
};
